<template>
    <v-container>
        <period-selector v-if="$vuetify.breakpoint.mdAndDown"></period-selector>

        <period-survey></period-survey>

        <content-dashboard
            v-if="$store.get('enrollment/selected@is_content_registration')"
        ></content-dashboard>

        <tryout-dashboard v-else></tryout-dashboard>
    </v-container>
</template>

<script>
import PeriodSelector from '@/components/dashboard/period/PeriodSelector'
import TryoutDashboard from './TryoutDashboard.vue'
import ContentDashboard from './ContentDashboard.vue'
import PeriodSurvey from './components/PeriodSurvey.vue'

export default {
    components: {
        PeriodSelector,
        TryoutDashboard,
        ContentDashboard,
        PeriodSurvey,
    },
}
</script>
